import React from 'react';
import { AuthProvider } from './modules/auth/AuthContext';
import { Route, Routes, Outlet } from 'react-router-dom';
import BookingComplete from './modules/client/booking/containers/BookingComplete/BookingComplete';
import AuthWrapper from './modules/auth/components/AuthWrapper';
import AuthPageLayout from './modules/auth/components/AuthPageLayout/AuthPageLayout';
import SignIn from './modules/auth/features/SignIn/SignIn';
import RedirectToDefault from './modules/navigation/RedirectToDefault';
import UnauthorisedScreen from './modules/auth/components/UnauthorisedScreen/UnauthorisedScreen';
import ProtectedRoute from './modules/auth/components/ProtectedRoute';
import { NavBar } from './modules/navigation/NavBar/NavBar';
import { OptionsProvider } from './contexts/OptionsContext';
import { ToastContainer } from 'react-toastify';
import RosterList from './modules/influencer/roster/RosterList/RosterList';
import CreatorPayments from './modules/finance/CreatorPayments/CreatorPayments';
import AdminBookings from './modules/admin/Bookings/AdminBookings';
import { ClientBookingProvider } from './modules/client/booking/ClientBookingContext/ClientBookingContext';
import CreateCampaign from './modules/client/booking/containers/CreateCampaign/CreateCampaign';
import ClientRosterList from './modules/client/roster/ClientRosterList/ClientRosterList';
import AdminInfluencers from './modules/admin/Influencers/AdminInfluencers';
import ForgotPassword from './modules/auth/features/ForgotPassword/ForgotPassword';
import ConfirmPassword from './modules/auth/features/ConfirmPassword/ConfirmPassword';
import CampaignsList from './modules/client/campaigns/CampaignsList/CampaignsList';
import CampaignDetails from './modules/client/campaigns/CampaignDetails/CampaignDetails';
import DataDownload from './modules/data/DataDownload/DataDownload';
import CampaignManagerInfluencers from './modules/campaignManager/influencers/CampaignManagerInfluencers';
import CampaignManagerBookings from './modules/campaignManager/bookings/CampaignManagerBookings';
import { ContentTagsProvider } from './contexts/ContentTagsContext';

function App() {
    return (
        <>
            <AuthProvider>
                <Routes>
                    <Route index element={<RedirectToDefault />} />

                    <Route
                        element={
                            <AuthPageLayout>
                                <Outlet />
                            </AuthPageLayout>
                        }
                    >
                        <Route path="sign-in" element={<SignIn />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="confirm-password" element={<ConfirmPassword />} />
                    </Route>

                    <Route
                        element={
                            <>
                                <NavBar />
                                <OptionsProvider>
                                    <ContentTagsProvider>
                                        <div className="pageContent">
                                            <Outlet />
                                        </div>
                                    </ContentTagsProvider>
                                </OptionsProvider>
                            </>
                        }
                    >
                        <Route path="roster" element={<RosterList />} />

                        <Route
                            element={
                                <AuthWrapper>
                                    <Outlet />
                                </AuthWrapper>
                            }
                        >
                            <Route
                                path="client"
                                element={
                                    <ProtectedRoute groups={['apex_client']} hasAccessWhenMatches="all">
                                        <ClientBookingProvider>
                                            <Outlet />
                                        </ClientBookingProvider>
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="roster/" element={<ClientRosterList />} />
                                <Route path="new-booking/" element={<CreateCampaign />} />
                                <Route path="booking-complete/" element={<BookingComplete />} />
                                <Route path="campaigns/" element={<CampaignsList />} />
                                <Route path="campaigns/:id" element={<CampaignDetails />} />
                            </Route>

                            <Route
                                path="campaign-manager"
                                element={
                                    <ProtectedRoute groups={['apex_manager']} hasAccessWhenMatches="all">
                                        <Outlet />
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="creators" element={<CampaignManagerInfluencers />} />
                                <Route path="bookings" element={<CampaignManagerBookings />} />
                            </Route>

                            <Route
                                path="finance"
                                element={
                                    <ProtectedRoute groups={['apex_finance']} hasAccessWhenMatches="all">
                                        <Outlet />
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="creator-payments" element={<CreatorPayments />} />
                            </Route>

                            <Route
                                path="admin"
                                element={
                                    <ProtectedRoute groups={['apex_admin']} hasAccessWhenMatches="all">
                                        <Outlet />
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="bookings" element={<AdminBookings />} />
                                <Route path="creators" element={<AdminInfluencers />} />
                            </Route>

                            <Route path="data">
                                <Route
                                    path="download"
                                    element={
                                        <ProtectedRoute groups={['apex_admin']} hasAccessWhenMatches="all">
                                            <DataDownload />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>

                            <Route path="unauthorised" element={<UnauthorisedScreen />} />
                        </Route>
                    </Route>
                </Routes>
            </AuthProvider>
            <ToastContainer />
        </>
    );
}

export default App;
